module.exports = __webpack_public_path__ + "img/sqlite-icon.332417a7.svg";